import Header from '../Shared-Component/Header/Header';
import Footer from '../Shared-Component/Footer/Footer';
import HeroBanner from './HeroBanner/HeroBanner';
import ImageSection from './ImageSection/ImageSection';
import VisitUs from './VisitUs/VisitUs'
import OurCampus from './OurCampus/OurCampus'
import RankHolder from './RankHolder/RankHolder';

const LandingPage = () => {
    return (
        < div className='landing-page'>
            <Header />
            <HeroBanner/>
            <ImageSection/>
            <VisitUs />
            <OurCampus/>
            <RankHolder/>
            <Footer />
        </div>
    )
}

export default LandingPage; 